<template>
  <div id="app">
    <block-header v-on="block_handlers" />
    <block-main v-on="block_handlers" />
    <!-- <block-lockdown v-if="lockdown_time" /> -->
    <!-- <BlockAdvertisement></BlockAdvertisement> -->
    <block-cars @close="closeThings" id="cars" v-on="block_handlers" />
    <block-credit v-on="block_handlers" />
    <block-stock v-on="block_handlers" :selected_model="selected_model" />
    <!-- <block-offer v-on="block_handlers" /> -->
    <block-advantages id="advantages" v-on="block_handlers" />
    <block-contacts @close="closeThings" id="contacts" v-on="block_handlers" />
    <block-footer />
    <!-- <block-legal v-on="block_handlers" /> -->
    <transition name="fade">
      <full-get
        :data="data"
        @close="closeThings"
        v-on="block_handlers"
        v-if="show.get"
      />
    </transition>

    <transition name="fade">
      <full-thanks @close="closeThings" v-if="show.thanks" />
    </transition>
    <transition name="fade">
      <full-agreement
        @close="closeAgreement"
        :type="agreement_type"
        v-if="show.agreement"
      />
    </transition>
    <preloader v-if="show.load"></preloader>
    <side-menu v-on="block_handlers"></side-menu>
  </div>
</template>

<script>
import BlockHeader from "./components/block-header";
import BlockMain from "./components/block-main";
import BlockLockdown from "./components/block-lockdown";
import BlockCars from "./components/block-cars";
import BlockOffer from "./components/block-offer";
import BlockCredit from "./components/block-credit";
import BlockAdvantages from "./components/block-advantages";
import BlockStock from "./components/block-stock";
import BlockContacts from "./components/block-contacts";
import BlockLegal from "./components/block-legal";
import BlockFooter from "./components/block-footer";
import FullGet from "./components/full-get";
import FullThanks from "./components/full-thanks";
import FullAgreement from "./components/full-agreement";
import Preloader from "./components/preloader";
import SideMenu from "./components/side-menu";
import BlockAdvertisement from "./components/block-advertisement.vue"


import Mixin from "./common/mixin";
import $ from "jquery";
import smoothScrollTo from "./common/smoothScrollTo";
import Send from "./common/send";

export default {
  name: "app",
  components: {
    BlockAdvertisement,
    BlockHeader,
    BlockMain,
    BlockLockdown,
    BlockCars,
    BlockOffer,
    BlockCredit,
    BlockAdvantages,
    BlockStock,
    BlockContacts,
    BlockLegal,
    BlockFooter,
    FullAgreement,
    FullGet,
    FullThanks,
    Preloader,
    SideMenu,
  },
  mixins: [Mixin],
  data: function () {
    return {
      show: {
        agreement: false,
        get: false,
        thanks: false,
        coupon: false,
        load: false,
      },
      data: {},
      agreement_type: "personal",
      selected_model: "",
    };
  },
  mounted() {
    $("html").on("keyup", (event) => {
      if (event.keyCode === 27) {
        this.closeThings();
      }
    });

    history.scrollRestoration = "manual";
    let hash = window.location.hash.replace("#", "");
    if (hash) {
      this.scrollTo(hash);
    }

    //setTimeout(() => {this.show.coupon = true},  5000);
  },
  computed: {
    block_handlers() {
      return {
        getAgreement: this.getAgreement,
        scrollTo: this.scrollTo,
        callBack: this.callThere,
        getCall: this.handleGetCall,
        getCoupon: this.handleGetCoupon,
        changeModel: this.changeCarModel,
      };
    },
    lockdown_time() {
      const today = new Date();
      const time = new Date(2021, 9, 28);
      if (today - time >= 0) {
        return true
      } else {
        return false;
      }
    }
  },
  methods: {
    closeThings() {
      this.show.get = false;
      this.show.thanks = false;
      this.show.agreement = false;
      this.show.coupon = false;
      this.data = {};
      this.unblockScroll();
    },
    closeAgreement() {
      this.show.agreement = false;
      if (!this.show.get) {
        this.unblockScroll();
      }
    },
    getAgreement(type) {
      this.show.agreement = true;
      this.agreement_type = type;
      this.blockScroll();
    },
    handleGetCoupon(data) {
      this.show.coupon = true;
      this.data = data;
      this.blockScroll();
    },
    handleGetCall(data) {
      this.show.get = true;
      this.data = data;
      this.blockScroll();
    },
    changeCarModel(model) {
      this.selected_model = model;
    },
    scrollTo(where) {
      let offset = this.device_platform === "desktop" ? 110 : 160;
      smoothScrollTo($("#" + where).offset().top - offset);
    },
    callThere(event) {
      let cKeeper = this.CONSTANTS.cKeeper,
        manager_phone = this.CONSTANTS.need_manager_phone
          ? $("#phone")
              .text()
              .replace(/\s/g, "\u00A0")
              .replace(/-/g, "\u2011")
              .replace(/\D+/g, "")
          : "",
        req = Send(event, this.data, cKeeper, manager_phone);
      this.show.load = true;

      if (cKeeper === "actioncall") {
        const finishCall = () => {
          this.closeThings();
          this.show.load = false;
          this.show.thanks = true;
          if (typeof window.dataLayer !== "undefined") {
            window.dataLayer.push({
              event: "callkeeper-call_order-ckaction",
              eventCategory: "callkeeper",
              eventAction: "call_order",
              eventLabel: "ckaction",
            });
          }
          console.log("done");
        };

        if (!req) {
          finishCall();
        } else {
          req.finally(finishCall);
        }
      } else {
        this.closeThings();
        this.show.load = false;
        this.show.thanks = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
